import { END_POINTS } from "../constants/urls";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  status: number;
  data?: any;
  message: string;
};

export const employeeApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubscription: builder.query<
      CommonResponse,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: `${END_POINTS.getSubscription}?search=${search}&pageNo=${page}`,
        method: "GET",
      }),
    }),

    addSubscription: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addSubscription,
        method: "POST",
        body,
      }),
    }),

    changeSubscriptionStatus: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.subscriptionStatus}/${id}`,
        method: "POST",
      }),
    }),

    getSubscriptionDetails: builder.query<
      CommonResponse,
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.subscriptionDetails}?Id=${id}`,
        method: "GET",
      }),
    }),

    updateSubscription: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: `${END_POINTS.editSubscription}`,
        method: "PATCH",
        body,
      }),
    }),

    deleteSubscription: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteSubscription}/${id}`,
        method: "DELETE",
      }),
    }),

    getTransactions: builder.query<
      CommonResponse,
      { search: string; page: number; body: any }
    >({
      query: ({ search, page, body }) => ({
        url: `${END_POINTS.transactions}?search=${search}&pageNumber=${page}`,
        method: "POST",
        body,
      }),
    }),

    getBookingPayments: builder.query<
      CommonResponse,
      { search: string; page: number; body: any }
    >({
      query: ({ search, page, body }) => ({
        url: `${END_POINTS.bookingPayments}?search=${search}&pageNumber=${page}`,
        method: "POST",
        body,
      }),
    }),

    getDirectLinkPayments: builder.query<
      CommonResponse,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: `${END_POINTS.directLinkPayment}?search=${search}&pageNumber=${page}`,
        method: "GET",
      }),
    }),

    cancelTransactionDetails: builder.query<
      CommonResponse,
      { search: string; page: number; body: any }
    >({
      query: ({ search, page, body }) => ({
        url: `${END_POINTS.cancelTransactionDetails}?search=${search}&pageNumber=${page}`,
        method: "POST",
        body,
      }),
    }),

    exportBookingPayment: builder.mutation<CommonResponse, { format: string }>({
      query: ({ format }) => ({
        url: `${END_POINTS.exportBookingPayment}?format=${format}`,
        method: "POST",
      }),
    }),

    exportSubscription: builder.mutation<CommonResponse, { format: string }>({
      query: ({ format }) => ({
        url: `${END_POINTS.exportUserPayment}?format=${format}`,
        method: "POST",
      }),
    }),

    exportDirectLinkPayment: builder.mutation<
      CommonResponse,
      { format: string }
    >({
      query: ({ format }) => ({
        url: `${END_POINTS.exportLinkData}?format=${format}`,
        method: "POST",
      }),
    }),

    exportCancelTransaction: builder.mutation<
      CommonResponse,
      { format: string }
    >({
      query: ({ format }) => ({
        url: `${END_POINTS.exportCancellation}?format=${format}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useLazyGetSubscriptionQuery,
  useAddSubscriptionMutation,
  useChangeSubscriptionStatusMutation,
  useLazyGetSubscriptionDetailsQuery,
  useUpdateSubscriptionMutation,
  useLazyDeleteSubscriptionQuery,
  useLazyGetTransactionsQuery,
  useLazyGetBookingPaymentsQuery,
  useLazyGetDirectLinkPaymentsQuery,
  useLazyCancelTransactionDetailsQuery,
  useExportBookingPaymentMutation,
  useExportSubscriptionMutation,
  useExportDirectLinkPaymentMutation,
  useExportCancelTransactionMutation,
} = employeeApi;
